export const getContent = (state, getters, rootState) => {
  const packageName = rootState.simulation.package;

  if (!packageName) {
    return null;
  }

  const parentPackage = packageName.indexOf('.') >= 0 ? packageName.split('.')[0] : null;

  const filteredContent = state.content.filter(offer => offer.subject.scope === '*' || offer.subject.scope === packageName || (parentPackage && offer.subject.scope === parentPackage));

  return filteredContent;
};

export const getValidOffers = (state, getters) => {
  const offers = getters.getContent.filter(offer => getters.isOfferValid(offer));

  const activeOffers = [];
  const displayOffers = offers.filter((offer) => {
    if (offer.subject.family) {
      if (activeOffers.includes(offer.subject.family)) {
        return false;
      }

      activeOffers.push(offer.subject.family);
    }

    return true;
  });

  return displayOffers;
};

export const getValidDiscountOffers = (state, getters) => {
  const offers = getters.getValidOffers.filter(offer => offer.subject.type === 'discount');

  const activeOffers = [];
  const displayOffers = offers.filter((offer) => {
    if (offer.subject.family) {
      if (activeOffers.includes(offer.subject.family)) {
        return false;
      }

      activeOffers.push(offer.subject.family);
    }

    return true;
  });

  return displayOffers;
};

export const getValidDiscountOffersValue = (state, getters) => {
  const offers = getters.getValidDiscountOffers;

  if (!offers.length) {
    return 0;
  }

  const mappedOffers = offers.map(offer => offer.subject.value);
  const total = mappedOffers.reduce((sum, x) => sum + x);

  return total;
};

export const getValidDiscountLoudOffers = (state, getters) => {
  const offers = getters.getValidDiscountOffers.filter(offer => !offer.subject.silentOnStrikedPrice);

  return offers;
};

export const getValidDiscountLoudOffersValue = (state, getters) => {
  const offers = getters.getValidDiscountLoudOffers;

  if (!offers.length) {
    return 0;
  }

  const mappedOffers = offers.map(offer => offer.subject.value);
  const total = mappedOffers.reduce((sum, x) => sum + x);

  return total;
};

export const getValidDiscountSilentOffers = (state, getters) => {
  const offers = getters.getValidDiscountOffers.filter(offer => offer.subject.silentOnStrikedPrice);

  return offers;
};

export const getValidDiscountSilentOffersValue = (state, getters) => {
  const offers = getters.getValidDiscountSilentOffers;

  if (!offers.length) {
    return 0;
  }

  const mappedOffers = offers.map(offer => offer.subject.value);
  const total = mappedOffers.reduce((sum, x) => sum + x);

  return total;
};

export const getValidPercentageOffers = (state, getters) => {
  const offers = getters.getValidOffers.filter(offer => offer.subject.type === 'percentage');

  const activeOffers = [];
  const displayOffers = offers.filter((offer) => {
    if (offer.subject.family) {
      if (activeOffers.includes(offer.subject.family)) {
        return false;
      }

      activeOffers.push(offer.subject.family);
    }

    return true;
  });

  return displayOffers;
};

export const getValidPercentageOffersValue = (satte, getters) => {
  const offers = getters.getValidPercentageOffers;

  if (!offers.length) {
    return 0;
  }

  const mappedOffers = offers.map(offer => offer.subject.value);
  const total = mappedOffers.reduce((sum, x) => sum + x);

  return total;
};

export const getValidExternalOffers = (state, getters) => {
  const offers = getters.getValidOffers.filter(offer => offer.subject.type === 'external');

  const activeOffers = [];
  const displayOffers = offers.filter((offer) => {
    if (offer.subject.family) {
      if (activeOffers.includes(offer.subject.family)) {
        return false;
      }

      activeOffers.push(offer.subject.family);
    }

    return true;
  });

  return displayOffers;
};

export const getValidInternalOffers = (state, getters) => {
  const offers = getters.getValidOffers.filter(offer => offer.subject.type === 'internal');

  const activeOffers = [];
  const displayOffers = offers.filter((offer) => {
    if (offer.subject.family) {
      if (activeOffers.includes(offer.subject.family)) {
        return false;
      }

      activeOffers.push(offer.subject.family);
    }

    return true;
  });

  return displayOffers;
};

export const isOfferVoid = (state, getters, rootState, rootGetters) => (_offer) => {
  // If any void path is active, the offer resolves to void.
  const voidItemsQuantity = _offer.relationships && _offer.relationships.void ? _offer.relationships.void.length : 0;

  if (voidItemsQuantity) {
    return _offer.relationships.void.some((path) => {
      // In a void relationship, an array means that all paths within the array are required to be active in order to void the offer
      if (Array.isArray(path)) {
        return path.every((itemPath) => {
          // If an element of an array is itself an array, at least one of the paths must be active in order to resolve that element to true
          if (Array.isArray(itemPath)) {
            return itemPath.some((subItemPath) => {
              const isExcluding = subItemPath.startsWith('!');
              const isWildcard = subItemPath.endsWith('*');
              const computedPath = subItemPath.replace('!', '').replace('*', '');

              if (isWildcard) {
                return isExcluding ? !rootGetters['cart/isPathBeginningWithActive'](computedPath)(computedPath) : rootGetters['cart/isPathBeginningWithActive'](computedPath);
              }

              return isExcluding ? !rootGetters['cart/isPathActive'](computedPath) : rootGetters['cart/isPathActive'](computedPath);
            });
          }

          const isExcluding = itemPath.startsWith('!');
          const isWildcard = itemPath.endsWith('*');
          const computedPath = itemPath.replace('!', '').replace('*', '');

          if (isWildcard) {
            return isExcluding ? !rootGetters['cart/isPathBeginningWithActive'](computedPath) : rootGetters['cart/isPathBeginningWithActive'](computedPath);
          }

          return isExcluding ? !rootGetters['cart/isPathActive'](computedPath) : rootGetters['cart/isPathActive'](computedPath);
        });
      }

      const isExcluding = path.startsWith('!');
      const isWildcard = path.endsWith('*');
      const computedPath = path.replace('!', '').replace('*', '');

      if (isWildcard) {
        return isExcluding ? !rootGetters['cart/isPathBeginningWithActive'](computedPath) : rootGetters['cart/isPathBeginningWithActive'](computedPath);
      }

      return isExcluding ? !rootGetters['cart/isPathActive'](computedPath) : rootGetters['cart/isPathActive'](computedPath);
    });
  }

  // If there are no defined relationships, the offer is not void.
  return false;
};

export const isOfferValid = (state, getters, rootState, rootGetters) => (_offer) => {
  // Bail if offer is void.
  if (getters.isOfferVoid(_offer)) {
    return false;
  }

  // If all required paths are active, the offer resolves to valid.
  const requiredItemsQuantity = _offer.relationships && _offer.relationships.required ? _offer.relationships.required.length : 0;

  if (requiredItemsQuantity) {
    return _offer.relationships.required.every((path) => {
      if (Array.isArray(path)) {
        return path.some(itemPath => rootGetters['cart/isPathActive'](itemPath));
      }

      return rootGetters['cart/isPathActive'](path);
    });
  }

  // If there are no defined relationships, the offer resolves to valid.
  return true;
};

export const isPathAnOffer = (state, getters) => (_path) => {
  const offers = getters.getContent.filter(offer => offer.subject.target === _path && getters.isOfferValid(offer));

  return !!offers.length;
};

export default {
  getContent,
  getValidOffers,
  getValidDiscountOffers,
  getValidDiscountOffersValue,
  getValidDiscountLoudOffers,
  getValidDiscountLoudOffersValue,
  getValidDiscountSilentOffers,
  getValidDiscountSilentOffersValue,
  getValidExternalOffers,
  getValidInternalOffers,
  getValidPercentageOffers,
  getValidPercentageOffersValue,
  isOfferVoid,
  isOfferValid,
  isPathAnOffer
};



// WEBPACK FOOTER //
// ./src/store/modules/offers/getters.js